export default "__VITE_ASSET__cHO7XAia__"